import { $host } from './index';

export const signIn = async (username, password) => {
  const res = await $host.post('signin', { username, password });

  const accessToken = res.data.token;
  localStorage.setItem('accessToken', accessToken);
  $host.defaults.headers['Authorization'] = `Bearer ${accessToken}`;

  return res;
};